import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { getGroups, Group, useGroups } from '../redux/slices/groups';

const useGetGroupOfTicket = (ticketGroupId: string) => {
	const [group, setGroup] = useState<Group>();
	const dispatch = useDispatch();
	const { groups } = useGroups();

	useEffect(() => {
		dispatch(getGroups());
	}, [dispatch]);

	useEffect(() => {
		if (ticketGroupId) {
			const group = groups.find((g) => g.id === ticketGroupId);
			setGroup(
				group || { id: '', name: 'Grupo Desconhecido', emailNotification: '', isFranchise: false }
			);
		}
	}, [ticketGroupId, groups]);

	return { group, ticketGroupId };
};

export default useGetGroupOfTicket;
